import React from "react";
import { useState } from "react";
import { Button, TextField } from "@mui/material";
import { useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { createVehicle, getGroupVehicles, getOrganizationData } from "./../../../services/api";
import { FilterBy } from "../../commons/filter.component";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";

const CreateVehicle = () => {
  const history = useHistory();
  const [t] = useTranslation();
  const [inputData, setInputData] = useState({
    code: "",
    owner_company: "",
    license_plate: "",
    groupvehicle: null,
    organization: null,
  });
  const handleCreateVehicle = () => {
    return createVehicle({
      ...inputData,
      groupvehicle_id: parseInt(inputData.groupvehicle?.id),
      organization_id: parseInt(inputData.organization?.id),
    });
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      history.push("/vehicle");
    }
  };
  return (
    <div align="left">
      <h1 align="center">{t("Thêm mới phương tiện")}</h1>
      <TextField label="ID" value={inputData.code} onChange={(e) => setInputData((prev) => ({ ...prev, code: e.target.value }))} fullWidth style={{ margin: "5px 0" }} />
      <TextField
        label={t("Công ty quản lý")}
        value={inputData.owner_company}
        onChange={(e) => setInputData((prev) => ({ ...prev, owner_company: e.target.value }))}
        fullWidth
        style={{ margin: "5px 0" }}
      />
      <TextField label={t("Biển số xe")} value={inputData.license_plate} onChange={(e) => setInputData((prev) => ({ ...prev, license_plate: e.target.value }))} fullWidth style={{ margin: "5px 0" }} />
      <FilterBy
        getDataFunc={() => getGroupVehicles({ status: 1 })}
        style={{ width: "100%", margin: "5px 0" }}
        value={inputData.groupvehicle}
        onChange={(e, newValue) => setInputData((prev) => ({ ...prev, groupvehicle: newValue }))}
      />
      <FilterBy
        getDataFunc={() => getOrganizationData({ status: 1 })}
        style={{ width: "100%", margin: "5px 0" }}
        value={inputData.organization}
        onChange={(e, newValue) => setInputData((prev) => ({ ...prev, organization: newValue }))}
      />
      <div align="center">
        <Button color="secondary" variant="contained" style={{ margin: 5 }} onClick={() => history.goBack()}>
          {t("Quay lại")}
        </Button>
        <ButtonWithAPICallComponent variant="contained" color="primary" api={handleCreateVehicle} response={handleResponse}>
          {t("Tạo mới")}
        </ButtonWithAPICallComponent>
      </div>
    </div>
  );
};

export default CreateVehicle;
